import Properties from "@/components/properties/Properties.vue";
import Connections from "@/components/connections/Connections.vue";
import Notes from "@/components/notes/Notes.vue";
import Documents from "@/components/documents/Documents.vue";
import Settings from "@/components/settings/Settings.vue";
import PropertyDetails from "@/components/properties/PropertyDetails.vue";
import EvaluationDetails from "@/components/properties/evaluations/EvaluationDetails.vue";
import Admin from "@/components/admin/Admin.vue";
import Help from "@/components/help/Help.vue";
import PrivacyPolicy from "@/components/policy/PrivacyPolicy.vue";
import TermsAndConditions from "@/components/policy/TermsAndConditions.vue";
import UniversalSignup from "@/components/subscribers/UniversalSignUp.vue";
import SignUp from "@/components/subscribers/SignUp.vue";
import Reactivate from "@/components/subscribers/Reactivate.vue";
import DiscoveryMigration from "@/components/subscribers/DiscoveryMigration.vue";
import IconViewer from "@/components/help/IconViewer.vue";
import store from "@/store.js";
import ListingView from "@/components/listings/public/View.vue";
import BPO from "@/components/properties/evaluations/multifamily/BPO.vue";
import BPO2 from "@/components/properties/evaluations/multifamily/BPO2.vue";
import BPO_PDF from "@/components/properties/evaluations/multifamily/BPO_PDF.vue";
import BPO2_PDF from "@/components/properties/evaluations/multifamily/BPO2_PDF.vue";
import LongForm from "@/components/properties/evaluations/multifamily/LongForm.vue";

export default routes;

export const routes = [
  // Display on menu.
  {
    path: "/properties",
    component: Properties,
    display: "Properties",
    style: "fas fa-home",
    visible: true,
    meta: {
      breadcrumb: "Properties"
    }
  },
  {
    path: "/connections",
    component: Connections,
    display: "Connections",
    style: "fas fa-users",
    visible: true,
    meta: {
      breadcrumb: "Connections"
    }
  },
  {
    path: "/notes",
    component: Notes,
    display: "Notes",
    style: "fas fa-comment",
    visible: true,
    meta: {
      breadcrumb: "Notes"
    }
  },
  {
    path: "/documents",
    component: Documents,
    display: "Documents",
    style: "fas fa-file",
    visible: false,
    meta: {
      breadcrumb: "Documents"
    }
  },
  {
    path: "/admin",
    component: Admin,
    display: "Admin",
    style: "fas fa-toolbox",
    visible: store.getters.session ? store.getters.session.rights.admin : false,
    meta: {
      breadcrumb: "Admin"
    }
  },
  // Non displayable routes.
  {
    path: "/help",
    component: Help,
    display: "Help",
    style: "fas fa-question",
    meta: {
      breadcrumb: "Help"
    }
  },
  {
    path: "/settings",
    component: Settings,
    display: "Settings",
    style: "fas fa-cog",
    meta: {
      breadcrumb: "Settings"
    }
  },
  {
    name: "Home",
    path: "/",
    component: Properties,
    props: true,
    meta: {
      breadcrumb: "Home"
    }
  },
  {
    name: "PropertyDetails",
    path: "/properties/:property_id",
    component: PropertyDetails,
    props: true,
    meta: {
      breadcrumb: "Details"
    }
  },
  {
    name: "EvaluationDetails",
    path: "/properties/:property_id/evaluations/:evaluation_id",
    component: EvaluationDetails,
    props: true,
    meta: {
      breadcrumb: "Evaluation"
    }
  },
  {
    name: "EvaluationDetailsPdf",
    path: ":pdfUrl",
    component: EvaluationDetails,
    props: true
  },
  {
    name: "EvaluationDetailsStandAlone",
    path:
      "/properties/:property_id/evaluations/:evaluation_id/sessions/:session_key",
    component: EvaluationDetails,
    props: true
  },
  // Public routes that don't require login.
  {
    name: "ListingView",
    path: "/properties/:property_id/listings/:listing_id",
    component: ListingView,
    props: true
  },
  {
    name: "PrivacyPolicy",
    path: "/policy/PrivacyPolicy.vue",
    component: PrivacyPolicy,
    public: true
  },
  {
    name: "TermsAndConditions",
    path: "/policy/TermsAndConditions.vue",
    component: TermsAndConditions,
    public: true
  },
  {
    universalSignup: "Signup",
    path: "/universalSignup",
    component: UniversalSignup,
    public: true
  },
  {
    name: "Signup",
    path: "/signup",
    component: SignUp,
    public: true
  },
  {
    name: "Reactivate",
    path: "/reactivate",
    component: Reactivate,
    public: true
  },
  {
    name: "DiscoveryMigration",
    path: "/discovery_migration",
    component: DiscoveryMigration,
    public: true
  },
  {
    name: "IconViewer",
    path: "/iconviewer",
    component: IconViewer,
    public: true
  },
  {
    name: "BPO",
    path: "/properties/:property_id/bpos/:bpo_id",
    component: BPO,
    public: true
  },
  {
    name: "BPO_PDF",
    path: "/properties/:property_id/bpos/:bpo_guid/pdf",
    component: BPO_PDF,
    public: true
  },
  {
    name: "BPO2",
    path: "/properties/:property_id/bpo2s/:bpo2_id",
    component: BPO2,
    public: true
  },
  {
    name: "BPO2_PDF",
    path: "/properties/:property_id/bpo2s/:bpo2_guid/pdf",
    component: BPO2_PDF,
    public: true
  },
  {
    name: "LongForm",
    path: "/properties/:property_id/longforms/:longform_id",
    component: LongForm,
    public: true
  },
  {
    name: "BpoSharingReadOnly",
    path: "/sharing/bpos/:property_id/:bpo_id/:guid",
    component: BPO,
    public: true
  },
  {
    name: "Bpo2SharingReadOnly",
    path: "/sharing/bpo2s/:property_id/:bpo2_id/:guid",
    component: BPO2,
    public: true
  },
  {
    name: "BpoSharingEdit",
    path: "/sharing/bpos/:property_id/:bpo_id/:guid/:editKey",
    component: BPO,
    public: true
  },
  {
    name: "Bpo2SharingEdit",
    path: "/sharing/bpo2s/:property_id/:bpo2_id/:guid/:editKey",
    component: BPO2,
    public: true
  }
];
